<template>
    <div class="bg-gradient-to-r flex from-xiaomi via-red-500 to-pink-500 rounded-lg text-white p-5">
        <div class="flex flex-col">
            <span class="mb-3">{{ type | verbose_insurance }}</span>

            <div class="flex opacity-75">
                <div class="flex flex-col">
                    <span>{{ product.model }}</span>
                    <span>Assuré pour une valeur de {{ product.price.toLocaleString('fr-FR', {style: "currency", currency: "EUR"}) }}</span>
                    <span v-if="product.imei">IMEI : {{ product.imei }}</span>
                    <span v-if="product.serial">Numéro de série : {{ product.imei }}</span>
                </div>
            </div>
        </div>

        <div class="ml-auto my-auto mr-5 hidden md:block">
            <svg class="w-10 h-10 opacity-50" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"></path></svg>
        </div>
    </div>  
</template>

<script>
export default {
    props: ['type', 'product']
}
</script>